import React from 'react';

function Resume(props) {
    return (
        <div>
            This is the Resume Page
        </div>
    );
}

export default Resume;